import { NoDelivery, Button, Heading, HeadingEnum, TextColorEnum } from '@desquared/wave-components-library';
import React from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import map from '../../../public/assets/wave-grocery/map.webp';

import styles from './NoDeliveryPage.module.css';

export default function NoDeliveryPage(props) {
  const router = useRouter();
  const t = useTranslations('common.asides.postal_check');
  const r = useTranslations('login_register');

  return (
    <div className={styles.outerContainer}>
      <Heading
        color={TextColorEnum.Gray1}
        type={HeadingEnum.HeadingS}
        classOption={styles.title}
        style={{ fontWeight: 700 }}
      >
        {t('select_title')}
      </Heading>
      <NoDelivery
        classOption={styles.paddingContainer}
        logo={props.logo}
        logoRedirect={router.locale === router.defaultLocale ? '/' : `/${router.locale}/`}
        noDeliveryImage={map.src}
        titleText={t('sorry')}
        description={t('soon')}
      />
      <div className={styles.footer}>
        <Button
          onClick={() => {
            router.push('/address-details');
          }}
          text={t('new_address')}
          variant="text"
          // disabled={isBoolean(isNotEligible) && isNotEligible}
        ></Button>
        <Button
          onClick={() => {
            router.push('/select-service');
          }}
          text={t('other_service')}
          variant={'filled'}
          // disabled={isBoolean(isNotEligible) && isNotEligible}
        ></Button>
      </div>
    </div>
  );
}
